module.exports = "/assets/images/angel.png";